import { render, staticRenderFns } from "./AdminDashboardView.vue?vue&type=template&id=4b827ebc&"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashboardView.vue?vue&type=style&index=0&id=4b827ebc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports